export default __webpack_public_path__ + "static/SOC_logo-ef4ccbc67876671e3b226d5d42fb62b6.png";